module.exports = __webpack_public_path__ + "img/IMG_7189_L_BlackMatted_MockedUp.204040d2.jpg";